import React, { useEffect, useState } from "react";
import { useMatch, useLocation } from "react-router-dom";
import "../../Assessts/Styles/Programs.scss";
import IOText from "../../ReUableComponents/ImageOntext";
import PSBanner from "../../Assessts/Images/Programs/PSBanner.png";

import SK1 from "../../Assessts/Images/Programs/Skill/SK1.JPG";
import SK2 from "../../Assessts/Images/Programs/Skill/SK2.JPG";
import SK3 from "../../Assessts/Images/Programs/Skill/SK3.JPG";
import SK4 from "../../Assessts/Images/Programs/Skill/SK4.JPG";

import SS1 from "../../Assessts/Images/Programs/Scholarship/SS1.JPG";
import SS2 from "../../Assessts/Images/Programs/Scholarship/SS2.JPG";
import SS3 from "../../Assessts/Images/Programs/Scholarship/SS3.JPG";

import SA1 from "../../Assessts/Images/Programs/Seva/SA1.JPG";
import SA2 from "../../Assessts/Images/Programs/Seva/SA2.JPG";
import SA3 from "../../Assessts/Images/Programs/Seva/SA3.JPG";
import SA4 from "../../Assessts/Images/Programs/Seva/SA4.JPG";
import SA5 from "../../Assessts/Images/Programs/Seva/SA5.JPG";

import MMP1 from "../../Assessts/Images/Programs/MMP/MMP1.JPG";
import MMP2 from "../../Assessts/Images/Programs/MMP/MMP2.JPG";
import MMP3 from "../../Assessts/Images/Programs/MMP/MMP3.JPG";
import MMP4 from "../../Assessts/Images/Programs/MMP/MMP4.JPG";



import Arrow from "../../Assessts/Images/Programs/Arrow.svg";
const PScholarships = () => {

    const isScholarship = Boolean(useMatch("/Programs/Scholarships"));
    const isSkills = Boolean(useMatch("/Programs/Skills"));
    const isSeva = Boolean(useMatch("/Programs/Seva"));
    const isMMP = Boolean(useMatch("/Programs/MMPrograms"));

    const location = useLocation();

    const [Index, SetIndex] = useState(0);
    const ScholarShip = [{
        BannerText: <div>Ensuring access to education through merit and need</div>,
        Heading: "Scholar Financial Support Program",
        Content: "The Scholarship Support Program ensures equitable access to higher education for meritorious and deserving students from underserved backgrounds. By offering financial assistance along with academic and mentoring support, the program helps scholars continue their education without disruption and successfully complete their academic journey.",
        PagePath: <div className=" PP-Deatils" >Programs  -  <span>Scholarship</span> • Skills • Service • Mentorship    </div>,
        SlidingImages: [SS1,SS2,SS3],
        ImageContent: [
            "Merit-cum-need based scholarships for deserving students",
            "Priority to first-generation learners",
            "Performance-linked scholarship renewals",
            "Timely academic and mentoring support"
        ]
    }
    ]

    const Skills = [{
        BannerText: <div>Preparing scholars for careers through <span style={{color:"#F7D670"}}>skills and confidence</span></div>,

        Heading: "Skill Development Program",
        Content: "The Skill Development Program aims to equip scholars with essential employability skills required to meet current market demands. Since most scholars come from rural and first-generation backgrounds with limited access to professional guidance, the program focuses on addressing gaps in interview readiness, workplace awareness, and career preparation to help scholars succeed in placements and professional environments.",
        PagePath: <div className=" PP-Deatils" >Programs  -  Scholarship • <span>Skills</span> • Service • Mentorship    </div>,
        SlidingImages: [SK1, SK2,SK3,SK4],
        ImageContent: [
            "Structured skill development based on Training Needs Analysis (TNA) of nearly 2,600 scholars",
            "Interview readiness through resume building, mock interviews, and professional etiquette",
            "Awareness of interview processes, evaluation criteria, and preparation strategies",
            "Practical learning through workshops and guided sessions",
            "Focus on employability, confidence building, and workplace readiness"
        ]
    }]

    const Seva = [{
        BannerText: <div>Gratitude in action through <span style={{color:"#F7D670"}}>service, empathy, and leadership</span></div>,
        Heading: "Seva (Community Service) Program",
        Content: "The Seva Program aims to instill gratitude, empathy, and social responsibility among scholars through active community service. As scholarship beneficiaries, scholars are encouraged to give back to society while developing leadership qualities, teamwork, and compassion through meaningful engagement with communities.",
        PagePath: <div className=" PP-Deatils" >Programs  -  Scholarship • Skills • <span>Service</span> • Mentorship    </div>,
        SlidingImages: [SA1, SA2, SA3, SA4 , SA5],
        ImageContent: [
            "Participation in meaningful community service activities",
            "Encouraging scholars to give back to society",
            "Activities that benefit local communities",
            "Development of leadership, teamwork, and compassion",
            "Promoting empathy and social responsibility"
        ]
    }]

    const MMP = [{
        BannerText: <div>Connecting experience and <span style={{color:"#F7D670"}}>guidance to shape future leaders</span></div>,
        Heading: "Mentor–Mentee Program",
        Content: "The Mentor–Mentee Program aims to support scholars by connecting them with experienced corporate professionals for guidance and mentorship. Through regular interactions and career conversations, mentors help scholars build confidence, gain clarity on career goals, and navigate academic and professional challenges, bridging the gap between education and industry.",
        PagePath: <div className=" PP-Deatils" >Programs  -  Scholarship • Skills • Service • <span>Mentorship</span>        </div>,
        SlidingImages: [MMP1, MMP2, MMP3, MMP4],
        ImageContent: [
            "Mentorship by experienced corporate professionals",
            "Regular guidance and career-focused conversations",
            "Real-world insights and industry exposure",
            "Support in academic and professional decision-making",
            "Confidence building and career clarity for scholars"
        ]
    }]
    const [PageData, SetPageData] = useState(ScholarShip[0]);
    const LoaData = () => {
        SetPageData();
        switch (true) {
            case isScholarship: SetPageData(ScholarShip[0]);
                break;
            case isSkills: SetPageData(Skills[0]);
                break;
            case isSeva: SetPageData(Seva[0]);
                break;
            case isMMP: SetPageData(MMP[0]);
                break;
        }
    }
    useEffect(() => {
        LoaData();
        const interval = setInterval(() => {
            SetIndex((prev) => (prev + 1) % PageData.SlidingImages.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [location.pathname]);
    return (
        <>
            <IOText Image={PSBanner} Alt="EMpower" Text={
                <>
                    <div className="Text-MainDiv w-100" >
                        {PageData?.BannerText}
                    </div>
                    {PageData?.PagePath}
                </>
            } />
            <div className="P-Content">
                <div className="Web-MainHeading">{PageData.Heading}</div>
                <p>{PageData.Content}</p>

                <div style={{ position: "relative" }}>
                    <img src={PageData.SlidingImages[Index]} alt={PageData.Heading} className="Main-Image" />
                    <div className=" Card PC-Content" >
                        <div className="Web-SubHeading dflex alignitems">What We Do</div>
                        {PageData.ImageContent.map((item) => (<div className="dflex alignitems">
                            <img src={Arrow} alt="Arrow" /> {item}
                        </div>))}
                    </div></div>
            </div>
        </>
    )
}
export default PScholarships;